export default __webpack_public_path__ + "static/media/clock.6655be2d.svg";